import React from 'react';
import { FaCheck, FaExclamation } from 'react-icons/fa';
import { useTempEdgeTranslator } from '../../../Hooks/useTranslation';
import { getStepClassName } from '../../../utils/helpers/stepClassName';
import '../../../assets/styles/components/FormStepper.css';

const FormStepper = ({ steps, activeStep, errors = {}, onSelect, testId = 'form-stepper' }) => {
  const { tempedgeTranslator } = useTempEdgeTranslator();

  const renderMarker = (step) => {
    if (errors[step.key]) return <FaExclamation aria-hidden="true" />;
    if (step.key < activeStep) return <FaCheck aria-hidden="true" />;
    return step.key;
  };

  return (
    <nav className="form-stepper" data-testid={testId}>
      <ol className="form-stepper-list" role="tablist">
        {steps.map((step) => (
          <li key={step.key} className={`form-stepper-item ${getStepClassName(step.key, activeStep, errors[step.key])}`}>
            <button
              type="button"
              role="tab"
              className="form-stepper-btn"
              aria-selected={step.key === activeStep}
              data-testid={step.testId}
              onClick={() => onSelect(step.key)}
            >
              <span className="form-stepper-marker">{renderMarker(step)}</span>
              <span className="form-stepper-label">{tempedgeTranslator(step.label)}</span>
            </button>
          </li>
        ))}
      </ol>
    </nav>
  );
};

export default FormStepper;
